export default __webpack_public_path__ + "69b1b7c5b21c4acedaa3b3ac2ce57250.woff2";